// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "claire_action_intent".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { claireActionIntentTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "claire_action_intent" table (1:1 with a DB row, on the wire). */
export const claireActionIntentAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    conversationId: z.string().nullable(),
    action: z.enum(claireActionIntentTypeValues),
    normalizedKey: z.string(),
    resourceId: z.string().nullable(),
    displayName: z.string().nullable(),
    metadata: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=claireActionIntent.js.map